var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDribbleAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-dribbles-arrow-angle_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-dribbles-arrow-angle_1",
    "data-name": "Icon-dribbles-arrow-angle \\u2013 1",
    clipPath: "url(#clip-Icon-dribbles-arrow-angle_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-dribbles-arrow-angle",
    transform: "translate(8789.142 -10572.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M3163.378-13418.952v-3.41l3.736,2.043,2.209-2.753,3.06,3.1,2.933-2.393,1.594,3.41,3.156-1.7,1.3,2.607h3.028",
    transform: "translate(-11951.566 24000.918)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-play-arrow",
    "data-name": "Icon material-play-arrow",
    d: "M12,7.5l1.109,5.48L12,18.46l8.611-5.48Z",
    transform: "translate(-8781.707 10569.553)",
    fill: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbleAngle);
export default __webpack_public_path__ + "static/media/dribble-angle.24512c5ceecaa086e3983b0709fcb6c6.svg";
export { ForwardRef as ReactComponent };